// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("../../common/Components/Form.bs.js");
let Hooks = require("../../../utils/Hooks.bs.js");
let React = require("react");
let View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
let Form__Label = require("../../common/Components/Form__Label.bs.js");
let TogglesGroup = require("../../../uikit/reason/molecules/TogglesGroup/TogglesGroup.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let Form__Checkbox = require("../../common/Components/Form__Checkbox.bs.js");
let ReactDatepicker = require("../../common/Components/ReactDatepicker.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");

let listingTypeOptions = [
  "ACTIVE",
  "COMING_SOON",
  "OFF_MLS"
];

let yesOrNoOptions = [
  "yes",
  "no"
];

function getYesOrNoOptionLabel(value) {
  if (value === "yes") {
    return "Yes";
  } else {
    return "No";
  }
}

function autocompleteStatus(status) {
  if (status !== undefined) {
    if (status === "ok") {
      return "Success";
    } else {
      return "Failure";
    }
  } else {
    return "Neutral";
  }
}

function WizardMlsTimingFields(props) {
  let __showAvailabilityToggles = props.showAvailabilityToggles;
  let willAcceptOffers = props.willAcceptOffers;
  let willShow = props.willShow;
  let onMlsAt = props.onMlsAt;
  let mlsListingType = props.mlsListingType;
  let offMlsLabel = props.offMlsLabel;
  let comingSoonLabel = props.comingSoonLabel;
  let activeLabel = props.activeLabel;
  let showAvailabilityToggles = __showAvailabilityToggles !== undefined ? __showAvailabilityToggles : true;
  let getListingTypeOptionLabel = value => {
    switch (value) {
      case "ACTIVE" :
        return activeLabel;
      case "COMING_SOON" :
        return comingSoonLabel;
      case "OFF_MLS" :
        return offMlsLabel;
    }
  };
  let previousMlsListingType = Hooks.usePrevious(mlsListingType.value);
  React.useEffect(() => {
    if (previousMlsListingType !== mlsListingType.value) {
      let match = mlsListingType.value;
      if (match !== undefined) {
        switch (match) {
          case "COMING_SOON" :
            willShow.onChange(false);
            willAcceptOffers.onChange(false);
            break;
          case "ACTIVE" :
          case "OFF_MLS" :
            willShow.onChange(true);
            willAcceptOffers.onChange(true);
            break;
        }
      }
    }
  }, [
    mlsListingType.value,
    previousMlsListingType
  ]);
  let tmp;
  if (props.comingSoonEnabled) {
    tmp = JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
      getOptionLabel: getListingTypeOptionLabel,
      getOptionValue: getListingTypeOptionLabel,
      onBlur: param => mlsListingType.onBlur(),
      onChange: mlsListingType.onChange,
      options: listingTypeOptions,
      value: mlsListingType.value,
      status: autocompleteStatus(mlsListingType.status)
    });
  } else {
    let match = mlsListingType.value;
    let tmp$1;
    if (match !== undefined) {
      switch (match) {
        case "ACTIVE" :
          tmp$1 = "yes";
          break;
        case "COMING_SOON" :
          tmp$1 = undefined;
          break;
        case "OFF_MLS" :
          tmp$1 = "no";
          break;
      }
    } else {
      tmp$1 = undefined;
    }
    tmp = JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
      getOptionLabel: getYesOrNoOptionLabel,
      getOptionValue: getYesOrNoOptionLabel,
      onBlur: param => mlsListingType.onBlur(),
      onChange: value => mlsListingType.onChange(value !== undefined ? (
          value === "yes" ? "ACTIVE" : "OFF_MLS"
        ) : undefined),
      options: yesOrNoOptions,
      value: tmp$1,
      status: autocompleteStatus(mlsListingType.status)
    });
  }
  let match$1 = mlsListingType.value;
  let tmp$2;
  let exit = 0;
  if (match$1 !== undefined) {
    switch (match$1) {
      case "ACTIVE" :
      case "COMING_SOON" :
        exit = 1;
        break;
      case "OFF_MLS" :
        tmp$2 = null;
        break;
    }
  } else {
    tmp$2 = null;
  }
  if (exit === 1) {
    let match$2 = mlsListingType.value;
    let tmp$3;
    if (match$2 !== undefined) {
      switch (match$2) {
        case "COMING_SOON" :
          tmp$3 = "Date planned to go Active on MLS";
          break;
        case "ACTIVE" :
        case "OFF_MLS" :
          tmp$3 = "Approximate MLS date";
          break;
      }
    } else {
      tmp$3 = "Approximate MLS date";
    }
    tmp$2 = JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
      width: 12,
      widthMd: 3,
      children: [
        JsxRuntime.jsx(Form__Label.make, {
          labelText: tmp$3
        }),
        JsxRuntime.jsx(ReactDatepicker.make, {
          placeholderText: "Approximate date",
          onChange: date => onMlsAt.onChange(date),
          selected: onMlsAt.value,
          minDate: props.minDate,
          maxDate: props.maxDate,
          status: onMlsAt.status
        }),
        JsxRuntime.jsx(Form__Components.FieldError.make, {
          valid: onMlsAt.valid
        })
      ]
    });
  }
  return JsxRuntime.jsxs(Form.Section.make, {
    tipbox: props.tipbox,
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: props.questionLabel
      }),
      tmp,
      JsxRuntime.jsx(Form__Components.FieldError.make, {
        valid: mlsListingType.valid
      }),
      JsxRuntime.jsx(View__Jsx3.make, {
        mt: "md",
        children: tmp$2
      }),
      showAvailabilityToggles ? JsxRuntime.jsx(View__Jsx3.make, {
          mt: "md",
          children: JsxRuntime.jsxs(TogglesGroup.make, {
            children: [
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: evt => willShow.onChange(evt.target.checked),
                checked: Stdlib_Option.getOr(willShow.value, false),
                disabled: false,
                label: "Will show prior to MLS",
                mobileStyles: true
              }),
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: evt => willAcceptOffers.onChange(evt.target.checked),
                checked: Stdlib_Option.getOr(willAcceptOffers.value, false),
                disabled: false,
                label: "Will accept offers prior to MLS",
                mobileStyles: true
              })
            ]
          })
        }) : null
    ]
  });
}

let FormSection;

let FormUtils;

let Cell;

let make = WizardMlsTimingFields;

exports.FormSection = FormSection;
exports.FormUtils = FormUtils;
exports.Cell = Cell;
exports.listingTypeOptions = listingTypeOptions;
exports.yesOrNoOptions = yesOrNoOptions;
exports.getYesOrNoOptionLabel = getYesOrNoOptionLabel;
exports.autocompleteStatus = autocompleteStatus;
exports.make = make;
/* Form Not a pure module */
